module.exports = __webpack_public_path__ + "img/2.dd66d638.png";